import React, { useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap';

import Modal from './Modal';

export default function NewButton() {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="invite_search">
      <Row>
        <Col xs={12} className="text-right">
          <Button
            bsStyle="primary"
            onClick={() => setShowModal(true)}
          >
            Add Affiliate Training Step
          </Button>
        </Col>

        <Modal show={showModal} onHide={() => setShowModal(false)} />
      </Row>
    </div>
  );
}
